// extracted by mini-css-extract-plugin
export default {"background":"Color_background__AGvp-","content":"Color_content__qEc1q","query":"Color_query__Tedf3","inverted":"Color_inverted__gM6Xt","count":"Color_count__oXD-s"};